import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Card, CardBody, Row } from "reactstrap";
import { connect } from 'react-redux';
import moments from 'moment'
import "moment/locale/es";

const TicketsStats = (props) => {

    // const customer_id = props.currentCompany.id;
    // const openedTickets = useSelector((state) => state.data.openedTickets);
    // const dispatch = useDispatch();

    const [stats, setStats] = useState(null);

    useEffect(() => {
       
        setStats(props.ticketsStats);
    }, [props.ticketsStats]);





    // Ocultar el card si no llegaron stats o si el array está vacío
    // (sin este check, renderizaba un Card con Row vacío).
    if (!Array.isArray(stats) || stats.length === 0) {
        return null;
    }


    return (
        <Card className="mb-3">
            <CardBody className="py-1">
                <Row>
                    {stats.map((item, index) => (
                        <Col key={index} xxl={true} xl={2} lg={3} md={3} sm={6} xs={6}>
                            <div className="text-center py-2 px-1">
                                <div className="text-muted mb-1" style={{ fontSize: 13 }}>{item.name}</div>
                                <h3 className="text-success mb-0">{item.value}</h3>
                            </div>
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    );
};

const mapStateToProps = (state) => {
    return {
        ticketsStats: state.data.ticketsStats
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(TicketsStats);